import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, FloatingLabel, Alert } from "react-bootstrap";
import PageTitle from './components/PageTitle';
import SecondaryFooter from './components/SecondaryFooter';
import { API_ENDPOINTS } from './config/api';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");

  useEffect(() => {
    if (window.sessionStorage.getItem('sessionExpired')) {
      alert('Your session has expired. Please log in again.');
      window.sessionStorage.removeItem('sessionExpired');
    }
    
    // Check for redirect parameter
    const urlParams = new URLSearchParams(window.location.search);
    const redirect = urlParams.get('redirect');
    if (redirect) {
      setRedirectUrl(redirect);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors
    setLoading(true);

    try {
      const res = await fetch(`${API_ENDPOINTS.AUTH}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        let message = "Sign in failed. Please try again.";
        try {
          const ct = res.headers.get("content-type") || "";
          if (ct.includes("application/json")) {
            const errorData = await res.json();
            if (errorData && typeof errorData.message === "string" && errorData.message.trim()) {
              message = errorData.message.trim();
            }
          } else {
            const text = await res.text();
            if (text && text.trim()) message = text.trim().slice(0, 300);
          }
        } catch {
          // keep default message
        }
        setError(message);
        return;
      }

      const data = await res.json();
      console.log("Login response data:", data); // 👈 this will help you debug
      
      if (data.token) {
        localStorage.setItem('token', data.token);
        if (data.user && data.user.programId) {
          localStorage.setItem('programId', data.user.programId);
        }
      }

      localStorage.setItem("userId", data.user.id);
      localStorage.setItem("role", data.user.role);
      localStorage.setItem("firstName", data.user.firstName);
      localStorage.setItem("lastName", data.user.lastName);
      localStorage.setItem("email", data.user.email);

      // Navigate based on role or redirect URL
      if (redirectUrl) {
        navigate(redirectUrl);
      } else {
        switch (data.user.role) {
          case "superuser":
            navigate("/super/dashboard");
            break;
          case "director":
            navigate("/dashboard");
            break;
          case "resident":
            navigate("/resident/dashboard");
            break;
          case "attending":
            navigate("/attending/dashboard");
            break;
          case "admin":
            navigate("/admin/dashboard");
            break;
          case "student":
            navigate("/student/dashboard");
            break;
          case "institutional_admin":
            navigate("/institutional-admin/dashboard");
            break;
          default:
            navigate("/");
        }
      }

    } catch (err) {
      setError("Network error. Please try again.");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="d-flex flex-column justify-content-center align-items-center min-vh-100">
      <PageTitle title="Login" description="Sign in to your MedHive account" />
      <div className="d-flex flex-column justify-content-center align-items-center flex-column-fluid">
      
      <div className="d-flex flex-column justify-content-center align-items-center flex-column-fluid">
      <div className="py-4 animate-logo">
        <img src="/images/asset11.svg" onClick={() => navigate("/")} alt="MedHive" className="img-fluid mb-3" style={{ height: "60px", cursor: "pointer" }} />
      </div>


          <Card className="p-md-5 p-4 shadow-sm border-0 rounded-4" style={{ width: "400px" }}>
          
              <Card.Header className="p-0 text-center mb-4 border-0 mt-md-0 mt-2">
                {/*<img src="/images/asset3.svg" onClick={() => navigate("/")} alt="MedHive" className="img-fluid mb-3" style={{ height: "60px", cursor: "pointer" }} />*/}
                <h5 className="text-center fw-semibold mb-0">Welcome Back!</h5>
                <p className="text-muted mb-0">Sign in to your account</p>
              
                </Card.Header>
         <Card.Body className="p-0 mt-3 mb-3">
              <Form onSubmit={handleLogin}>
                {error ? (
                  <Alert variant="danger" className="mb-3 py-2 small" role="alert">
                    {error}
                  </Alert>
                ) : null}

                <Form.Group>
       <FloatingLabel controlId="floatingInput" label="Email address" className="mb-3">  
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required

                    disabled={loading}
                  />
                   </FloatingLabel>

                </Form.Group>

                <Form.Group className="mb-3">
                  <FloatingLabel controlId="floatingPassword" label="Password" className="mb-3">
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                    disabled={loading}
                  />
                  </FloatingLabel>
                  <div className="text-end mt-2 login-signup-link">
                    <Button 
                      variant="link"
                      size="sm"
                      onClick={() => navigate("/forgot-password")}
                      className="text-decoration-none p-0 fw-normal  "
                    >
                      Forgot Password?
                    </Button>
                  </div>
                </Form.Group>

                <Button 
                  type="submit" 
                  variant="primary" 
                  className="w-100 py-2 fw-semibold mb-3"
                  disabled={loading}
                >
                  {loading ? "Signing In..." : "Sign In"}
                </Button>

                <div className=" d-flex justify-content-center align-items-center login-signup-link">
                  <span className="me-1 text-muted small">Don't have an account?{" "}</span>
                  <Button 
                    variant="link"
                    size="sm"
                    onClick={() => navigate("/signup")}
                    className="text-decoration-none p-0"
                  >
                    Sign up
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
      </div>
      <SecondaryFooter />
      
      </div>
    </Container>
  );
};

export default Login;